import React from 'react'
import { Button } from '@frontend/ui-kit/agromarket/components/Button'
import type { ErrorApiModalProps } from '@/components/composed/modals/ErrorApiModal/types'
import { GlassMorphIcon } from '@/components/ui'
import { messages } from './messages'
import './styles.scss'

const ErrorApiModal = (props: ErrorApiModalProps) => {
  const { options } = props
  const { message, responseId, onSupport, onConfirm } = options

  return (
    <section className="errorApiModal">
      <GlassMorphIcon image="red/error" />

      <h3 className="errorApiModal__title">{messages.title}</h3>
      <p className="errorApiModal__message">{`${message}`}</p>
      {responseId && <p className="errorApiModal__code">{`${messages.code} ${responseId}`}</p>}

      <div className="errorApiModal__buttons">
        <Button variant="secondary" size="lg" onClick={onSupport}>
          {messages.button.support}
        </Button>

        <Button variant="primary" size="lg" onClick={onConfirm}>
          {messages.button.confirm}
        </Button>
      </div>
    </section>
  )
}

export default ErrorApiModal
